import React from 'react'

import { Label } from '@/atoms/Typography'
import Richtext from '@/atoms/RichText'
import Icon from '@/atoms/Icon'

import { StyledNoResults } from './styles'

const NoResults = ({
  title = 'Non ci sono risultati',
  description = 'Non riusciamo a trovare quello che stai cercando. Controlla di aver scritto correttamente ed effettua un’altra ricerca.'
}) => (
  <StyledNoResults className='NoResults'>
    <Icon name="no-results" unlockedProportions useIconColor />
    <Label bold center typo="heading2" as="h2">{title}</Label>
    <Richtext center typo="paragraphRegular" as="p">{description}</Richtext>
  </StyledNoResults>
)

export default NoResults
